import _t, {_} from 'i18n'
import moment from 'moment'
import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

import {Container, Icon, IconContainer, Label} from './styles'

const Status = ({iconSize = '8px', height = '20px', type, status, width = '20px', lg, lostAt, completedAt}) => {
  const getStatus = () => {
    if (status === 'open') return _`Ativa`
    if (status === 'lost') return _`Perdida`
    if (status === 'pending') return _`Pendente - Aguardando aprovação`
    return _`Ganha / Concretizada`
  }

  return (
    <Container status={status}>
      <IconContainer type={type} style={{display: 'flex', alignItems: 'center'}}>
        <Icon status={status} iconSize={iconSize} height={height} width={width}>
          <div style={lg ? {width: 16, height: 16, borderWidth: 5} : {}} />
        </Icon>
      </IconContainer>

      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="language-panel-tooltip">
            {status == 'completed' && completedAt
              ? _t('Concretizada em {date}', {date: moment(completedAt).format('DD/MM/YYYY hh:mm')})
              : null}
            {status == 'lost' && lostAt
              ? _t('Perdida em {date}', {date: moment(lostAt).format('DD/MM/YYYY hh:mm')})
              : null}
            {status == 'open' && (completedAt || lostAt) ? _`Oportunidade foi re-ativada` : null}
            {status == 'open' && !(completedAt || lostAt) ? _`Oportunidade ativa` : null}
            {status == 'pending' ? _`Oportunidade cadastrada via vitrine econômica, aguardando aprovação` : null}
          </Tooltip>
        }>
        <Label status={status}>{getStatus()}</Label>
      </OverlayTrigger>
    </Container>
  )
}

export default Status
